// extracted by mini-css-extract-plugin
export var footer = "_qx-0";
export var inherit = "_qx-1";
export var input = "_qx-2";
export var modalContent = "_qx-3";
export var quillEditor = "_qx-4";
export var subtitle = "_qx-5";